import { ChatHeader } from '@/templates/software/rovo/start/software-rovo-start-page/src/chat';

const UniformRovoChatHeader = () => {
	return <ChatHeader />;
};

export default UniformRovoChatHeader;
